import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DatabasetabComponent } from './databasetab.component';

const routes: Routes = [
  {
    path: '',
    component: DatabasetabComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DatabasetabRoutingModule {}
